// import { SocketHandlerInterface } from '../sockets/SocketHandler'
import SwivlChatInterface from '../interface/SwivlChatInterface'
import { browserName, browserVersion } from "react-device-detect";


import {
        ActionTaken,
        Message,
        MessageType,
        SenderOrRecipient,
        SenderOrRecipientType,
        isAuth,
        createCreateUserAndStartConversationMessage,
        createTextMessage,
        createActionTakenMessage,
        createStartConversationMessage,
        createAuthMessage,
        createTypingMessage,
        TypingPayloadActionType
      } from '@swivl/swivl-lib'
      
import SwivlChat from '../SwivlChat';
import { Config } from '../Config/Config';


export interface MessageHandlerInterface {
  handleMessage(message:Message):void;
  sendTextMessage(text:string):void;
  actionTaken(messageId:string, actionTaken:ActionTaken):void;
  loadPastMessages(olderThanMessage?:Message):Promise<Array<Message>>;
  getNewLocations(messageId:string, zipCode:string, searchRadiusInMeters:number)
}

export class MessageHandler implements MessageHandlerInterface {
  delegate: SwivlChat;
  messageIdsSent:string[]
  
  hasSoundLoaded = false; 
  dingSound?:HTMLAudioElement;



  constructor(delegate:SwivlChat) {
    this.delegate = delegate;
    this.messageIdsSent = [];
  }

  handleMessage(message:Message):void {
    // if (!isMessage(message)) { console.warn("malformed message",message); return; }
    if (message.type === MessageType.Auth)           { this.handleAuthMessage(message);    return; }
    if (message.type === MessageType.Text)           { 
      this.playSoundIfNeededForMessage(message);
      this.handleGenericMessage(message); return; 
    }
    if (message.type === MessageType.ProfileCollect)         { this.handleGenericMessage(message); return; }

    if (message.type === MessageType.Typing)         { this.handleGenericMessage(message); return; }
    if (message.type === MessageType.Buttons)        { this.handleGenericMessage(message); return; }
    if (message.type === MessageType.Carousel)       { this.handleGenericMessage(message); return; }
    if (message.type === MessageType.LocationPicker) { this.handleGenericMessage(message); return; }
    if (message.type === MessageType.SpacePicker)    { this.handleGenericMessage(message); return; }
    if (message.type === MessageType.TakeoverEvent)  { 
      this.loadSoundIfNeeded(false)
      this.handleGenericMessage(message); return; }
    if (message.type === MessageType.MultiSelect)    { this.handleGenericMessage(message); return; }
    if (message.type === MessageType.Media)          { this.handleGenericMessage(message); return; }
    if (message.type === MessageType.Command)        { this.handleGenericMessage(message);
                                                      this.delegate.commandHandler.handleCommandMessage(message);
                                                      return; }

    if (message.type === MessageType.StartConversation || 
        message.type === MessageType.ActionTaken
      ) { return; }
                                             
    console.warn("Unhandled Message Type", message);
  }

  handleAuthMessage(message:Message):void {

    if (isAuth(message.payload)) {
      if (message.payload.type === SenderOrRecipientType.Agent ) {  return; }
      if (this.delegate.state.auth?.type === SenderOrRecipientType.Agent ) { return; }
      this.delegate.updateAuth(message.payload);
    } else { console.warn("Invalid Auth Message", message); }
  }

  handleGenericMessage(message:Message):void {
    if (this.delegate.state.auth && 
        message.from && 
        // !this.messageIdsSent.includes(message.id) && 
        this.delegate.list) {

          this.delegate.list?.addMessagesToList([message]);
    } else {

    } 
  }




  private to(): SenderOrRecipient {
    return { id:Config.botId, type:SenderOrRecipientType.Bot }
  }

  private from(): SenderOrRecipient {
    if (this.delegate.props.from) {
      return this.delegate.props.from;
    }
    let botUserId = (this.delegate.state.auth && this.delegate.state.auth?.botUserId) ? this.delegate.state.auth.botUserId : null;
    const type = (this.delegate.state.auth && this.delegate.state.auth.type === SenderOrRecipientType.Agent) ? SenderOrRecipientType.Agent : SenderOrRecipientType.BotUser;
    if (!botUserId) { throw new Error("Missing Bot USer Id Param"); }
    return { id:botUserId, type:type};
  }



  /**
   * This method sends the message to the socket handler as well as the message list.
   * @param  {[type]} message [description]
   * @return {[type]}         [description]
   */
  private sendMessage(message:Message) {
    this.messageIdsSent.push(message.id);
    this.delegate.socketHandler.sendMessage(message);
    if (this.delegate.list) {

      this.delegate.list?.addMessagesToList([message]);
    }


  }

  sendTypingFrame(isTyping:boolean) {
    const type  = (isTyping) ?  TypingPayloadActionType.Started :  TypingPayloadActionType.Ended
    const message = createTypingMessage(this.to(), this.from(),type);
    this.sendMessage(message);
  }

  sendAuthMessage() {
    if (this.delegate.state.auth &&
        this.delegate.state.auth.botId &&
        this.delegate.state.auth.botUserId &&
        this.delegate.state.auth.type &&
        this.delegate.state.auth.token) {
    const message = createAuthMessage(this.to(),
                                      this.from(),
                                      this.delegate.state.auth.botId,
                                      this.delegate.state.auth.botUserId,
                                      this.delegate.state.auth.type,
                                      this.delegate.state.auth.token);

    this.sendMessage(message);

  } else {

  }
  }

  sendCreateUserAndStartConversation() {
    let startOnQuest =  (Config && Config.startOnQuest) ? Config.startOnQuest : null;
    if (this.delegate.props.startOnQuestId) {
      startOnQuest = this.delegate.props.startOnQuestId
    }

    let preloadVariables = this.delegate.props.preloadVariables;
    if (Config.preloadVariables) {
      preloadVariables = {...Config.preloadVariables, ...preloadVariables}
    }

    const message = createCreateUserAndStartConversationMessage(Config.botId,startOnQuest, preloadVariables);
    (message as any).browser = `${browserName} ${browserVersion}`

    this.sendMessage(message);
  }
  
  sendStartConversation() {
    let startOnQuest =  (Config && Config.startOnQuest) ? Config.startOnQuest : null;
    if (this.delegate.props.startOnQuestId) {
      startOnQuest = this.delegate.props.startOnQuestId
    }
    let preloadVariables = this.delegate.props.preloadVariables;
    if (Config.preloadVariables) {
      preloadVariables = {...Config.preloadVariables, ...preloadVariables}
    }
    let message = createStartConversationMessage(this.to(), this.from(), Config.botId, startOnQuest, preloadVariables);
    (message as any).browser = `${browserName} ${browserVersion}`

    this.sendMessage(message)
  }
  sendTextMessage(text:string) {
    this.delegate.hideModal()
    this.sendMessage(createTextMessage(this.to(), this.from(), text, false));
  }
  actionTaken(messageId:string, actionTaken:ActionTaken) {
    if(this.delegate.props.transcriptOnly) { return; }


    
    this.delegate.list?.addActionTakenToItemInList(messageId, actionTaken);
    const message = createActionTakenMessage(this.to(), this.from(), messageId,  actionTaken);

    this.delegate.socketHandler.sendMessage(message);
  }

  loadTranscript(transcriptDate:Date):Promise<Array<Message>> {
    const auth:any  = this.delegate.state.auth;
    if (!auth) { console.warn("No user"); return Promise.reject("No user") }
    let olderThan = ''
    // if (olderThanMessage && (olderThanMessage.created || olderThanMessage.received)) {
    //   if (olderThanMessage.received) {
    //     olderThan = `&olderThan=${olderThanMessage.received}`
    //   } else {
    //     olderThan = `&olderThan=${olderThanMessage.created}`
    //   }
    // }

    olderThan = `&olderThan=${transcriptDate.getTime()}`

    const URL = `https://${this.delegate.props.server}/pastmessages?botUserId=${auth.botUserId}&token=${auth.token}&limit=30${olderThan}`;

    return fetch(URL).then(data=>{return data.json()});
  }


  loadPastMessages(olderThanMessage?:Message):Promise<Array<Message>> {
    const auth:any  = this.delegate.state.auth;
    if (!auth) { console.warn("No user"); return; }
    let olderThan = ''
    if (olderThanMessage && (olderThanMessage.created || olderThanMessage.received)) {
      if (olderThanMessage.received) {
        olderThan = `&olderThan=${olderThanMessage.received}`
      } else {
        olderThan = `&olderThan=${olderThanMessage.created}`
      }
    }
    const URL = `https://${this.delegate.props.server}/pastmessages?botUserId=${auth.botUserId}&token=${auth.token}&limit=30${olderThan}`;

    return fetch(URL).then(data=>{return data.json()});
  }

  getNewLocations(messageId:string, zipCode:string, searchRadiusInMeters:number) {
    const auth:any  = this.delegate.state.auth;

    const URL = `https://${this.delegate.props.server}/lookup-table/storefinder/update-message?botUserId=${auth.botUserId}&token=${auth.token}&zip=${zipCode}&messageId=${messageId}&searchRadiusInMeters=${searchRadiusInMeters}`;

    
    return fetch(URL).then(data=>{
      if (data.status > 250) {
        return data.json().then(r => { console.warn("Error fetching locations",r); Promise.reject(r) })
      }
      return data.json().then(r =>{

        this.delegate.list?.updateMessage(messageId, r)
    })
  });

  }

  loadSoundIfNeeded(shouldPlayOnLoad:boolean) {
    if ( this.hasSoundLoaded ) {

      
      return; 
    }
    this.dingSound = new Audio('https://swivl-cdn.s3-us-west-1.amazonaws.com/message_alert.m4a');
    this.dingSound.volume = 0.5;  
    this.dingSound.oncanplaythrough = (event) => {

        this.hasSoundLoaded = true; 
        if (shouldPlayOnLoad) {

          
        this.dingSound.play()
      };
    }
  }
  playDing() {
    if (this.hasSoundLoaded) {

      this.dingSound.play()
    } else {

      
      this.loadSoundIfNeeded(true)
    }
  }
  playSoundIfNeededForMessage(message:Message) {

    
    if (
      (!this.delegate.props.canTakeOver && message.from.type === SenderOrRecipientType.Agent)
      ||
      (this.delegate.props.canTakeOver && message.from.type === SenderOrRecipientType.BotUser)) {

        this.playDing()
    } 
  }
}
